/**
 * The FaqCategories List container
 */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import faqcategoriesActions from "../../redux/faqcategories";
import { push } from "connected-react-router";
import { Container, Row, Col } from "reactstrap";
// import {setLanguage} from "redux-i18n";
import Page from "../../components/Page";
import FaqAutocompleteSearch from "../../components/FaqAutocompleteSearch";
import FaqCategoriesListView from "../../components/FaqCategoriesListView";
import notificationsActions from "../../redux/notifications";
import fileguideIcon from "../../assets/images/icons/fileguide_colored.svg";
import { useSsrEffect } from "@issr/core";

/**
 * Selects props from the store and passes them to the component
 * @param {Object} state the store
 */
const mapStateToProps = (state) => ({
  faqcategories: state.faqcategories.list,
  language: state.i18nState.lang,
});
/**
 * Binds dispatch method to the actions passed as props to the component
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      listFaqCategories: faqcategoriesActions.list,
      notify: notificationsActions.showAlert,
      navigateTo: push,
    },
    dispatch
  );

/**
 * The `index` container to show a list of faqcategories
 * Both the component and the connected component are exported for testing purpose.
 * If storing resources is activated, this page will show a list of stored faqcategories when offline
 */
const SupportCenter = (props, context) => {
  const { language, faqcategories, navigateTo, listFaqCategories } = props;

  /**
   * Frontload function called before component mounts to
   * prefetch the list of faqcategories
   */
  const frontload = async () => {
    // await props.listFormSteps();
    // console.log("Language Changed", language);
    listFaqCategories();
  };
  /** navigates to the show faqcategory page if user has permission */
  const handleShowFaqCategory = (faqcategory_id, event) => {
    navigateTo(`/${language}/faqs/${faqcategory_id}/`);
  };

  useSsrEffect(frontload, [listFaqCategories, language]);
  return (
    <Page
      id="supportcenter"
      title={context.t("Help and Support on myfolie products and services")}
      lang={language}
      pageType="support"
      description={context.t(
        "In our FAQ Database we've extensive information on our products and services"
      )}
      image="https://cdn.myfolie.de/media/banner/800x500.png"
    >
      <div className="hero">
        <div className="hero__bg"></div>
        <header className="hero__content">
          <Container>
            <Row>
              <Col sm={12} md={{ size: 6, offset: 3 }}>
                <h1>{context.t("Support Center")}</h1>
                <p>
                  {context.t(
                    "Please try first searching our frequently asked questions and help section."
                  )}
                </p>
                <FaqAutocompleteSearch />
              </Col>
            </Row>
          </Container>
        </header>
      </div>

      <Container className="my-3">
        <h2>{context.t("Frequently Asked Questions")}</h2>
        <p>
          {context.t(
            "In our FAQ Database you can find help and tutorials on various topics. If you do not find the help you need we are more than happy if you drop us a line so we can extend our support center to your convenience."
          )}
        </p>
      </Container>

      <FaqCategoriesListView
        faqcategories={faqcategories.filter(
          (category) => !category.slug.startsWith("fileguide-")
        )}
        handleShowFaqCategory={handleShowFaqCategory.bind(this)}
      />

      <Container className="my-5">
        <h2>{context.t("Production Data Guidelines")}</h2>
        <Row>
          <Col xs={1}>
            <a href={`/${language}/fileguide/`} className="text-dark">
              <img
                className="w-100"
                src={fileguideIcon}
                alt={context.t("Production Data Guidelines")}
              />
            </a>
          </Col>
          <Col xs={8}>
            <p>
              {context.t(
                "Our Guidelines cover the most important aspecs on how your production data needs to be delivered. Please read it carefully and prepare your files accordingly. If your files are not aligned with the guidelines the result might look different than expected. In doubt we recommend adding a professional filecheck for each file that you want to have checked."
              )}
              <br />
              <br />
              <a href={`/${language}/fileguide/`}>
                &raquo; {context.t("Production Data Guidelines")}
              </a>
            </p>
          </Col>
        </Row>
      </Container>
      <Container className="my-5">
        <h2>{context.t("Contact")}</h2>
        <p>
          <a href={`/${language}/kontakt/`}>
            {context.t("Please use our Contact Form")}
          </a>
        </p>
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
SupportCenter.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default connect(mapStateToProps, mapDispatchToProps)(SupportCenter);
